import { useState } from "react";
import api, { apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { Button, Field, Input } from "@/components/ui-kit";

/** Máscara de telefone brasileiro: (99) 99999-9999 (também aceita fixo de 10 dígitos). */
const maskPhone = (v) => {
  const d = String(v || "").replace(/\D/g, "").slice(0, 11);
  if (d.length <= 10) return d.replace(/(\d{2})(\d)/, "($1) $2").replace(/(\d{4})(\d)/, "$1-$2");
  return d.replace(/(\d{2})(\d)/, "($1) $2").replace(/(\d{5})(\d)/, "$1-$2");
};

export default function Profile() {
  const { user } = useAuth();
  const [form, setForm] = useState({ name: user?.name || "", phone: maskPhone(user?.phone || "") });
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try { await api.put("/me/profile", form); toast.success("Dados atualizados"); }
    catch (e) { toast.error(apiError(e)); }
    finally { setSaving(false); }
  };

  return (
    <div className="max-w-md space-y-4" data-testid="profile-page">
      {/* Área do cliente: rótulo em sentence case, não em caixa alta de painel. */}
      <Field label="Nome completo" labelTone="plain">
        <Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
          autoComplete="name" size="lg" data-testid="profile-name-input" />
      </Field>
      <Field label="Telefone / WhatsApp" labelTone="plain" hint="Usamos para avisar sobre a entrega.">
        <Input value={form.phone} onChange={(e) => setForm({ ...form, phone: maskPhone(e.target.value) })}
          placeholder="(11) 99999-9999" inputMode="tel" autoComplete="tel" size="lg" data-testid="profile-phone-input" />
      </Field>
      <Field label="E-mail" labelTone="plain" hint="Não pode ser alterado — é por ele que você entra.">
        <Input value={user?.email || ""} disabled size="lg" className="bg-slate-50 text-slate-400" />
      </Field>
      <Button onClick={save} loading={saving} size="lg" data-testid="profile-save-btn">
        {saving ? "Salvando..." : "Salvar dados"}
      </Button>
    </div>
  );
}
